import i18next from "i18next";
// One instance per bundle: the apps and the shared packages all resolve this module once
// (it is a peer dependency of the shared packages), so a language switch reaches every namespace.
export const i18n = i18next.createInstance();
//# sourceMappingURL=instance.js.map